module.exports = __webpack_public_path__ + "static/media/mens_soccer.93468bf7.jpg";